import apiClient from './api';

async function fetchAll(data) {
  try {
    const response = await apiClient.get('/get-days-off', data || {});
    return response;
  } catch (error) {
    console.error('Error fetching all days off:', error);
    throw error;
  }
}

async function accept(data) {
    try {
      const response = await apiClient.post('/review-day-off-request', {
        ...data,
        approved: 1
      });
      return response;
    } catch (error) {
      console.error('Error creating day off:', error);
      throw error;
    }
  }

  async function reject(data) {
    try {
      const response = await apiClient.post('/review-day-off-request', {
        ...data,
        approved: 0
      });
      return response;
    } catch (error) {
      console.error('Error creating day off:', error);
      throw error;
    }
  }

  async function multaccept(data) {
    try {
      const response = await apiClient.post('/multiple-days-off-accept', {
        ...data,
        approved: 1
      });
      return response;
    } catch (error) {
      console.error('Error creating day off:', error);
      throw error;
    }
  }

  async function multreject(data) {
    try {
      const response = await apiClient.post('/multiple-days-off-reject', {
        ...data,
        approved: 0
      });
      return response;
    } catch (error) {
      console.error('Error creating day off:', error);
      throw error;
    }
  }

  async function createBulkDayOff(data) {
    try {
      const response = await apiClient.post('/create-bulk-days-off', data);
      return response;
    } catch (error) {
      console.error('Error creating bulk days off:', error);
      throw error;
    }
  }
  

export { fetchAll, accept, reject, multaccept, multreject, createBulkDayOff };
